class TokenService {
    
    private TOKEN_KEY = 'auth_token';
    //private REFRESH_TOKEN_KEY = 'refresh_token';

    getToken(): string | null {
        return localStorage.getItem(this.TOKEN_KEY)
    }

    getTokenOrDefault(defaultIfNoToken: string): string {
        let token = localStorage.getItem(this.TOKEN_KEY)

        return token || defaultIfNoToken;
    }

    saveToken(accessToken: string): void {
        localStorage.setItem(this.TOKEN_KEY, accessToken)
    }

    removeToken(): void {
        localStorage.removeItem(this.TOKEN_KEY)
    }

    // getRefreshToken() {
    //     return localStorage.getItem(this.REFRESH_TOKEN_KEY)
    // }

    // saveRefreshToken(refreshToken: string) {
    //     localStorage.setItem(this.REFRESH_TOKEN_KEY, refreshToken)
    // }

    // removeRefreshToken() {
    //     localStorage.removeItem(this.REFRESH_TOKEN_KEY)
    // }
}

export const tokenService = new TokenService();